import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .BonusManagementTable {
    .ReactDataTable__wrapper {
      .ReactDataTable {
        tr {
          grid-template-columns:
            minmax(40px, 0.5fr) /* logo */
            minmax(120px, 1.4fr) /* title */
            minmax(100px, 1fr) /* type */
            minmax(100px, 1fr) /* value */
            minmax(80px, 0.5fr); /* actions */
        }

        .ReactDataTable__tbody-row {
          height: 70px;
        }

        .ReactDataTable__tbody-cell:first-child img {
          width: rem(30px);
          height: rem(30px);
          border-radius: 50%;
          object-fit: cover;
        }

        .ReactDataTable__tbody-cell:nth-child(3) .BonusManagementTable__types {
          display: flex;
          flex-direction: column;
        }

        .ReactDataTable__tbody-cell:nth-child(4) .MoneyCell__inner span {
          font-size: rem(15px) !important;
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;

      span {
        text-align: center;
        padding: 5px 0;

        &:first-child {
          flex: 1; /* logo */
        }

        &:nth-child(2) {
          flex: 10; /* title */
        }

        &:nth-child(3) {
          flex: 6; /* value */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__preview-description {
        .ResponsiveTable__row-item {
          justify-content: flex-start;
          padding-left: 22%;
          .BonusManagementTable__types {
            display: flex;
            gap: 5px;
          }
        }
      }

      &--opened .ResponsiveTable__row-details .BonusManagementTable__types {
        display: flex;
        gap: 5px;
      }

      .ResponsiveTable__row-item {
        display: flex;
        align-items: center;

        &:first-child {
          flex: 1; /* logo */
          img {
            width: rem(30px);
            height: rem(30px);
            border-radius: 50%;
            object-fit: cover;
          }
        }

        &:nth-child(2) {
          flex: 10; /* title */
          font-weight: 500;
          font-size: rem(14px);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        &:nth-child(3) {
          flex: 6; /* value */
          font-size: rem(13px);
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .BonusManagementTable {
      .defaultType {
        color: ${colors.gray.hex};
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
